import React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import classNames from 'classnames'

/**
 * @import import { Drop } from '@/components/dragDrop'
 * @param {object} props
 * @param {string} props.droppableId Unique id for react-beautiful-dnd
 * @param {string} [props.type] Only rows dragged from a Drop of the same type can drop here
 * @param {boolean} [props.condensed] Tighter spacing for compact lists
 * @param {boolean} [props.isDropDisabled] Prevents rows from being dropped into this list
 */
export const Drop = ({ droppableId, type, condensed, isDropDisabled = false, ...props }) => {
  return (
    <Droppable droppableId={droppableId} type={type} isDropDisabled={isDropDisabled}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={classNames('droppable-area', {
              'is-dragging-over': snapshot.isDraggingOver,
              condensed,
            })}
            {...props}
          >
            {props.children}
            {provided.placeholder}
          </div>
        )
      }}
    </Droppable>
  )
}
